<script>
import { TheMask } from 'vue-the-mask'

import SelectPool from '@/components/catalog/SelectPool.vue'
import SelectRegionList from '@/components/catalog/SelectRegionList.vue'
import SelectRegionRestricted from '@/components/catalog/SelectRegionRestricted.vue'
import SelectDistrict from '@/components/catalog/SelectDistrict.vue'
import SelectRoles from '@/components/catalog/SelectRoles.vue'
import SelectStatus from '@/components/catalog/SelectStatus.vue'
import SelectReportStatus from '@/components/catalog/SelectReportStatus.vue'
import SelectReservoirsList from '@/components/catalog/SelectReservoirsList.vue'
import SelectPlots from '@/components/catalog/SelectPlots.vue'
import StateList from '@/components/catalog/StateList.vue'
import SelectBrigades from '@/components/catalog/SelectBrigades.vue'
import SelectReservoirTypes from '@/components/catalog/SelectReservoirTypes.vue'
import OrganizationTypeList from '@/components/components/Inputs/OrganizationTypeList.vue'
import CatchFishType from '@/components/components/Inputs/CatchFishType.vue'
import SelectFish from '@/components/catalog/SelectFish.vue'
import Multiselect from 'vue-multiselect'

export default {
	name: 'MainFilters',
	components: {
		TheMask,
		SelectPool,
		SelectRegionList,
		SelectRegionRestricted,
		SelectDistrict,
		SelectRoles,
		SelectStatus,
		SelectReportStatus,
		SelectReservoirsList,
		SelectPlots,
		StateList,
		SelectBrigades,
		SelectReservoirTypes,
		OrganizationTypeList,
		CatchFishType,
		SelectFish,
		Multiselect, // add
	},
	props: {
		filterKeys: {
			type: Array,
			default: () => [
				'search',
				'pools',
				'regions',
				'districts',
				'roles',
				'status',
				'reservoirs',
				'iin_bin',
				'state',
				'start_at',
				'finish_at',
				'brigades',
				'reservoirTypes',
				'catch_type',
				'catch_fish_type',
				'fishes',
			],
		},
		filterOptions: {
			type: Object,
			default: () => ({
				pools: {
					multiple: true,
					confinesValue: [],
				},
				regions: {
					multiple: true,
					confinesValue: [],
				},
				districts: {
					multiple: true,
					confinesValue: [],
				},
				roles: {
					multiple: true,
				},
				status: {
					multiple: true,
					confinesValue: [],
				},
				reservoirs: {
					multiple: true,
					confinesValue: [],
				},
				plots: {
					multiple: true,
				},
				state: {
					multiple: true,
				},
				brigades: {
					multiple: true,
				},
				reservoirTypes: {
					multiple: true,
				},
				catch_type: {
					multiple: true,
				},
				catch_fish_type: {
					multiple: true,
				},
				fishes: {
					multiple: true,
				},
			}),
		},
		restrictedRegionIds: {
			type: Array,
			default: () => [],
		},
		useReportStatus: {
			type: Boolean,
			default: false,
		},
		// id субъекта, чьи справочники (водоёмы, участки и бригады) нужно показать в фильтрах.
		// Для ГО/ТИР это id просматриваемого субъекта, для самого субъекта — его собственный id.
		userId: {
			type: [Number, String],
			default: null,
		},
	},
	data() {
		return {
			filters: {
				search: null,
				pools: null,
				regions: null,
				districts: null,
				roles: null,
				status: null,
				reservoirs: null,
				plots: null,
				iin_bin: null,
				state: null,
				start_at: null,
				finish_at: null,
				brigades: null,
				reservoirTypes: null,
				catch_type: null,
				catch_fish_type: null,
				fishes: null,
				fishing_year: null, // new
			},
			fishingYearOptions: [
				{
					id: 1,
					label: '1.07.2024 - 30.06.2025',
					start: '2024-07-01',
					finish: '2025-06-30',
				},
				{
					id: 2,
					label: '1.07.2025 - 31.12.2025',
					start: '2025-07-01',
					finish: '2025-12-31',
				},
				{
					id: 3,
					label: '01.01.2026 - 31.12.2026',
					start: '2026-01-01',
					finish: '2026-12-31',
				},
			],
		}
	},
	computed: {
		reservoirOptions() {
			return this.userId
				? this.$store.state.catalogs.userPonds || []
				: this.$store.state.catalogs.ponds || []
		},
		plotOptions() {
			return this.userId
				? this.$store.state.catalogs.userPlots || []
				: this.$store.state.catalogs.plots || []
		},
		// Участки субъекта приходят без регионов, поэтому сужаем их только по водоёмам.
		plotFilters() {
			if (!this.userId || !this.filters.reservoirs) return {}
			const reservoirs = Array.isArray(this.filters.reservoirs)
				? this.filters.reservoirs
				: [this.filters.reservoirs]
			return { reservoirs: reservoirs.map((reservoir) => reservoir.id) }
		},
		brigadeOptions() {
			return this.$store.state.catalogs.brigades || []
		},
		isNeededFilter() {
			return (name) => {
				// Hide pool filter for TIR users on quotas page
				if (
					name === 'pools' &&
					this.$store.state.userObject?.role_id === 9 &&
					this.$route.path.includes('/account/quotas/')
				) {
					return false
				}
				return this.filterKeys.includes(name)
			}
		},
	},
	watch: {
		'filters.regions': {
			handler(newVal) {
				let regionIds = []
				if (Array.isArray(newVal)) {
					regionIds = newVal.map((r) => r.id)
				} else if (newVal && newVal.id) {
					regionIds = [newVal.id]
				}
				if (regionIds.length) {
					this.$store.dispatch('_fetchDistricts', { regions: regionIds })
				}
				this.filters.districts = null
				this.filters.reservoirs = null
			},
			deep: true,
		},
		'filters.start_at'(val) {
			// Only clear fishing_year if it's not the one that set this start_at
			if (val && this.filters.fishing_year && this.filters.fishing_year.start !== val) {
				this.filters.fishing_year = null
			}
		},
		'filters.finish_at'(val) {
			// Only clear fishing_year if it's not the one that set this finish_at
			if (val && this.filters.fishing_year && this.filters.fishing_year.finish !== val) {
				this.filters.fishing_year = null
			}
		},
		'filters.fishing_year'(val) {
			if (val) {
				this.filters.start_at = val.start
				this.filters.finish_at = val.finish
			} else {
				// Only clear dates if fishing_year is explicitly set to null
				this.filters.start_at = null
				this.filters.finish_at = null
			}
		},
		// Справочники догружаются асинхронно — как только пришли, подставляем
		// в фильтры реальные элементы вместо id из query-строки.
		reservoirOptions() {
			this.hydrateFilterOptions()
		},
		plotOptions() {
			this.hydrateFilterOptions()
		},
		brigadeOptions() {
			this.hydrateFilterOptions()
		},
		// Watch for route query changes to sync filters
		'$route.query': {
			handler(newQuery) {
				this.syncFiltersFromRoute(newQuery)
			},
			immediate: true,
			deep: true,
		},
	},
	mounted() {
		// Initialize filters from route query parameters
		this.syncFiltersFromRoute(this.$route.query)
	},
	methods: {
		syncFiltersFromRoute(query) {
			// Sync each filter from route query
			this.filterKeys.forEach((key) => {
				// Handle special case for regions[] parameter
				const queryValue = query[key] || query[`${key}[]`]
				if (queryValue !== undefined && queryValue !== null && queryValue !== '') {
					// Handle array parameters (regions[], pools[], etc.)
					if (Array.isArray(queryValue)) {
						if (key === 'regions') {
							// Convert region IDs to region objects
							const regionIds = queryValue
							const availableRegions = this.$store.state.catalogs.regions || []
							this.filters[key] = regionIds.map(
								(id) =>
									availableRegions.find((region) => region.id == id) || {
										id,
										title: `Region ${id}`,
									},
							)
						} else if (key === 'pools') {
							// Convert pool IDs to pool objects
							const poolIds = queryValue
							const availablePools = this.$store.state.catalogs.pools || []
							this.filters[key] = poolIds.map(
								(id) =>
									availablePools.find((pool) => pool.id == id) || {
										id,
										title: `Pool ${id}`,
									},
							)
						} else if (key === 'reservoirs') {
							// Convert reservoir IDs to reservoir objects
							const reservoirIds = queryValue
							const availableReservoirs = this.reservoirOptions
							this.filters[key] = reservoirIds.map(
								(id) =>
									availableReservoirs.find((reservoir) => reservoir.id == id) || {
										id,
										title: `Reservoir ${id}`,
									},
							)
						} else if (key === 'plots') {
							this.filters[key] = queryValue.map(
								(id) => this.plotOptions.find((plot) => plot.id == id) || { id, title: String(id) },
							)
						} else if (key === 'brigades') {
							// Convert brigade IDs to brigade objects
							const availableBrigades = this.brigadeOptions
							this.filters[key] = queryValue.map(
								(id) =>
									availableBrigades.find((brigade) => brigade.id == id) || {
										id,
										title: String(id),
									},
							)
						} else if (key === 'roles') {
							// Map role IDs to role option objects
							const roleIds = queryValue
							const availableRoles = this.$store.state.catalogs.roles || []
							this.filters[key] = roleIds.map(
								(id) => availableRoles.find((role) => role.id == id) || { id, title: `Role ${id}` },
							)
						} else if (key === 'status') {
							// Map status values to status option objects
							const statusIds = queryValue
							const availableStatuses = (this.$t('orders.user') || []).map((e) => ({
								id: e.status,
								title: e.name,
							}))
							this.filters[key] = statusIds.map(
								(id) => availableStatuses.find((s) => s.id == id) || { id, title: id },
							)
						} else if (key === 'catch_type') {
							// Ensure ids are numbers for OrganizationTypeList
							this.filters[key] = queryValue.map((id) => Number(id))
						} else if (key === 'fishes') {
							// Convert fish IDs to fish objects (from handbook-fishes)
							const fishIds = queryValue
							const availableFishes = this.$store.state.catalogs.fishes || []
							this.filters[key] = fishIds.map(
								(id) =>
									availableFishes.find((fish) => fish.id == id) || {
										id,
										title: `Fish ${id}`,
									},
							)
						} else {
							// For other array filters, store IDs as-is
							this.filters[key] = queryValue
						}
					} else if (key === 'iin_bin') {
						this.filters[key] = queryValue
					} else if (key === 'start_at' || key === 'finish_at') {
						this.filters[key] = queryValue
					} else if (key === 'fishing_year') {
						// Handle fishing_year - find matching option based on start/finish dates
						const startDate = query.start_at
						const finishDate = query.finish_at
						if (startDate && finishDate) {
							const matchingOption = this.fishingYearOptions.find(
								(option) => option.start === startDate && option.finish === finishDate,
							)
							if (matchingOption) {
								this.filters.fishing_year = matchingOption
							}
						}
					} else if (key === 'regions') {
						// Single region id -> region object
						const availableRegions = this.$store.state.catalogs.regions || []
						const id = queryValue
						this.filters[key] = availableRegions.find((region) => region.id == id) || {
							id,
							title: `Region ${id}`,
						}
					} else if (key === 'pools') {
						const availablePools = this.$store.state.catalogs.pools || []
						const id = queryValue
						this.filters[key] = availablePools.find((pool) => pool.id == id) || {
							id,
							title: `Pool ${id}`,
						}
					} else if (key === 'reservoirs') {
						const availableReservoirs = this.reservoirOptions
						const id = queryValue
						this.filters[key] = availableReservoirs.find((reservoir) => reservoir.id == id) || {
							id,
							title: `Reservoir ${id}`,
						}
					} else if (key === 'plots') {
						const id = queryValue
						const plot = this.plotOptions.find((option) => option.id == id) || {
							id,
							title: String(id),
						}
						this.filters[key] = this.filterOptions?.plots?.multiple ? [plot] : plot
					} else if (key === 'brigades') {
						const availableBrigades = this.brigadeOptions
						const id = queryValue
						this.filters[key] = availableBrigades.find((brigade) => brigade.id == id) || {
							id,
							title: String(id),
						}
					} else if (key === 'roles') {
						const availableRoles = this.$store.state.catalogs.roles || []
						const id = queryValue
						this.filters[key] = availableRoles.find((role) => role.id == id) || {
							id,
							title: `Role ${id}`,
						}
					} else if (key === 'status') {
						const availableStatuses = (this.$t('orders.user') || []).map((e) => ({
							id: e.status,
							title: e.name,
						}))
						const id = queryValue
						this.filters[key] = availableStatuses.find((s) => s.id == id) || { id, title: id }
					} else if (key === 'catch_type') {
						// Keep numeric id for OrganizationTypeList
						this.filters[key] = Number(queryValue)
					} else if (key === 'fishes') {
						const availableFishes = this.$store.state.catalogs.fishes || []
						const id = queryValue
						this.filters[key] = availableFishes.find((fish) => fish.id == id) || {
							id,
							title: `Fish ${id}`,
						}
					} else {
						// For single values, store as-is
						this.filters[key] = queryValue
					}
				}
			})

			// Handle fishing_year based on start_at and finish_at if they exist
			if (!this.filters.fishing_year && (query.start_at || query.finish_at)) {
				const startDate = query.start_at
				const finishDate = query.finish_at
				if (startDate && finishDate) {
					const matchingOption = this.fishingYearOptions.find(
						(option) => option.start === startDate && option.finish === finishDate,
					)
					if (matchingOption) {
						this.filters.fishing_year = matchingOption
					}
				}
			}
		},
		hydrateFilterOptions() {
			const resolve = (value, list) => {
				if (!value || !list.length) return value
				const pick = (item) => {
					const id = item && typeof item === 'object' ? item.id : item
					return list.find((option) => option.id == id) || item
				}
				return Array.isArray(value) ? value.map(pick) : pick(value)
			}
			this.filters.reservoirs = resolve(this.filters.reservoirs, this.reservoirOptions)
			this.filters.plots = resolve(this.filters.plots, this.plotOptions)
			this.filters.brigades = resolve(this.filters.brigades, this.brigadeOptions)
		},
		search() {
			// If fishing_year is set, use its dates
			if (this.filters.fishing_year) {
				this.filters.start_at = this.filters.fishing_year.start
				this.filters.finish_at = this.filters.fishing_year.finish
			}
			// Don't clear fishing_year if it's set - let the user control it
			const newFilters = this.filterKeys.reduce((acc, key) => {
				// Skip fishing_year as it's handled separately
				if (key === 'fishing_year') {
					return acc
				}
				if (this.filters[key]) {
					if (Array.isArray(this.filters[key])) {
						// Handle arrays: if objects, map to ids; if primitives, keep as-is
						if (this.filters[key].length > 0 && typeof this.filters[key][0] === 'object') {
							acc[key] = this.filters[key].map((item) => item.id)
						} else {
							acc[key] = this.filters[key]
						}
					} else if (key === 'iin_bin') {
						acc[key] = this.filters[key].replaceAll(' ', '')
					} else if (typeof this.filters[key] === 'object' && this.filters[key] !== null) {
						acc[key] = this.filters[key].id
					} else if (
						typeof this.filters[key] === 'string' ||
						typeof this.filters[key] === 'number'
					) {
						acc[key] = this.filters[key]
					}
				} else if (this.$route.query[key]) {
					delete this.$route.query[key]
				}
				return acc
			}, {})
			// Special handling for regions: always use regions[]
			const query = { ...this.$route.query }
			delete query.regions
			delete query['regions[]']
			if (newFilters.regions) {
				query['regions[]'] = newFilters.regions
				delete newFilters.regions
			}
			// Special handling for catch_type: route-specific param name
			if (newFilters.catch_type) {
				// Clean any previous keys to prevent duplication
				delete query['catch_type']
				delete query['catch_type_id']
				delete query['catch_type_id[]']
				if (this.$route.path.includes('/account/trade-list')) {
					// Keep key without [] so axios will serialize arrays as catch_type_id[]
					query['catch_type_id'] = newFilters.catch_type
				} else {
					// For monitoring and others, keep as catch_type; page will convert to filters[catch_type_id]
					query['catch_type'] = newFilters.catch_type
				}
				delete newFilters.catch_type
			}
			// Add start_at and finish_at from fishing_year if set
			if (this.filters.fishing_year) {
				query['start_at'] = this.filters.fishing_year.start
				query['finish_at'] = this.filters.fishing_year.finish
			}

			// Check if filters have actually changed
			const hasFilterChanges =
				Object.keys(newFilters).length > 0 ||
				this.filters.fishing_year ||
				this.filters.start_at ||
				this.filters.finish_at

			this.$router.replace({
				query: {
					...query,
					...newFilters,
					page: hasFilterChanges ? 1 : this.$route.query.page || 1, // Only reset page if filters changed
					filterTime: new Date().getTime(),
				},
			})
			this.$emit('search')
		},
		clearFilter() {
			// Reset all local filters
			this.filters = Object.fromEntries(Object.entries(this.filters).map(([key]) => [key, null]))

			// Clear all URL query parameters except page and per_page
			const query = { ...this.$route.query }
			Object.keys(query).forEach((key) => {
				if (key !== 'page' && key !== 'per_page') {
					delete query[key]
				}
			})

			// Reset page to 1 when clearing filters
			query.page = 1
			query.filterTime = new Date().getTime()

			// Update the URL without triggering search
			this.$router.replace({ query })

			// Emit search event to refresh the data
			this.$emit('search')
		},
	},
}
</script>

<template>
	<div class="w-full row gap-y-2">
		<div v-if="isNeededFilter('status')" class="col-12 col-md-6 col-lg-3">
			<SelectReportStatus
				v-if="useReportStatus"
				:value="filters.status"
				:with-title="false"
				:multiple="filterOptions?.status?.multiple"
				:confinesValue="filterOptions?.status?.confinesValue"
				:placeholder="$t('filters.select_status')"
				@input="filters.status = $event"
			/>
			<SelectStatus
				v-else
				:value="filters.status"
				:with-title="false"
				:multiple="filterOptions?.status?.multiple"
				:confinesValue="filterOptions?.status?.confinesValue"
				:placeholder="$t('filters.select_status')"
				@input="filters.status = $event"
			/>
		</div>

		<div v-if="isNeededFilter('iin_bin')" class="col-12 col-md-6 col-lg-3">
			<label class="search__label">
				<TheMask
					v-model="filters.iin_bin"
					:masked="true"
					:name="'iin_bin'"
					:placeholder="$t('filters.enter_iin')"
					:mask="['### ### ### ###']"
					type="text"
					class="input-linck"
				/>
			</label>
		</div>
		<div v-if="isNeededFilter('search')" class="col-12 col-md-6 col-lg-3">
			<label class="search__label">
				<input
					v-model="filters.search"
					type="text"
					name="filter_search"
					:placeholder="$t('filters.search_by_name')"
				/>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
			</label>
		</div>
		<div v-if="isNeededFilter('pools')" class="col-12 col-md-6 col-lg-3">
			<SelectPool
				:value="filters.pools"
				:with-title="false"
				:multiple="filterOptions?.pools?.multiple"
				:confinesValue="filterOptions?.pools?.confinesValue"
				:placeholder="$t('filters.select_pond')"
				@input="filters.pools = $event"
			/>
		</div>

		<div v-if="isNeededFilter('regions')" class="col-12 col-md-6 col-lg-3">
			<SelectRegionRestricted
				v-if="restrictedRegionIds && restrictedRegionIds.length"
				:value="filters.regions"
				:ids="restrictedRegionIds"
				:with-title="false"
				:multiple="filterOptions?.regions?.multiple"
				:placeholder="$t('filters.search_by_region')"
				@input="filters.regions = $event"
			/>
			<SelectRegionList
				v-else
				:value="filters.regions"
				:filters="{
					pools: filters.pools
						? Array.isArray(filters.pools)
							? filters.pools.map((pool) => pool.id)
							: filters.pools.id
						: null,
				}"
				:watch-values="[filters.pools]"
				:with-title="false"
				:multiple="filterOptions?.regions?.multiple"
				:confinesValue="filterOptions?.regions?.confinesValue"
				:placeholder="$t('filters.search_by_region')"
				@input="filters.regions = $event"
			/>
		</div>
		<div v-if="isNeededFilter('districts')" class="col-12 col-md-6 col-lg-3">
			<SelectDistrict
				:value="filters.districts"
				:filters="{
					pools: filters.pools
						? Array.isArray(filters.pools)
							? filters.pools.map((pool) => pool.id)
							: filters.pools.id
						: null,
					regions: filters.regions
						? Array.isArray(filters.regions)
							? filters.regions.map((region) => region.id)
							: filters.regions.id
						: null,
				}"
				:watch-values="[filters.pools, filters.regions]"
				:with-title="false"
				:multiple="filterOptions?.districts?.multiple"
				:confinesValue="$store.getters._getDistricts"
				:placeholder="$t('filters.select_district')"
				@input="filters.districts = $event"
			/>
		</div>
		<div v-if="isNeededFilter('reservoirs')" class="col-12 col-md-6 col-lg-3">
			<SelectReservoirsList
				:value="filters.reservoirs"
				:user-id="userId"
				:with-title="false"
				:multiple="filterOptions?.reservoirs?.multiple"
				:confinesValue="filterOptions?.reservoirs?.confinesValue"
				:filters="{
					regions: filters.regions
						? Array.isArray(filters.regions)
							? filters.regions.map((r) => r.id)
							: [filters.regions.id]
						: null,
				}"
				:watch-values="[filters.regions]"
				:placeholder="$t('filters.select_reservoir')"
				@input="filters.reservoirs = $event"
			/>
		</div>
		<div v-if="isNeededFilter('plots')" class="col-12 col-md-6 col-lg-3">
			<SelectPlots
				:value="filters.plots"
				:user-id="userId"
				:with-title="false"
				:multiple="filterOptions?.plots?.multiple"
				:filters="plotFilters"
				:placeholder="$t('placeholder.select_plot')"
				@input="filters.plots = $event"
			/>
		</div>
		<div v-if="isNeededFilter('reservoirTypes')" class="col-12 col-md-6 col-lg-3">
			<SelectReservoirTypes
				:value="filters.reservoirTypes"
				:with-title="false"
				:multiple="filterOptions?.reservoirTypes?.multiple"
				:confinesValue="filterOptions?.reservoirTypes?.confinesValue"
				:placeholder="$t('filters.select_reservoir_type')"
				@input="filters.reservoirTypes = $event"
			/>
		</div>
		<div v-if="isNeededFilter('roles')" class="col-12 col-md-6 col-lg-3">
			<SelectRoles
				:value="filters.roles"
				:with-title="false"
				:multiple="filterOptions?.roles?.multiple"
				:placeholder="$t('filters.select_role')"
				@input="filters.roles = $event"
			/>
		</div>
		<div v-if="isNeededFilter('state')" class="col-12 col-md-6 col-lg-3">
			<StateList
				:value="filters.state"
				:with-title="false"
				:multiple="filterOptions?.state?.multiple"
				:placeholder="$t('filters.select_record_type')"
				@input="filters.state = $event"
			/>
		</div>
		<div v-if="isNeededFilter('catch_type')" class="col-12 col-md-6 col-lg-3">
			<OrganizationTypeList
				:value="filters.catch_type"
				:with-title="false"
				:multiple="filterOptions?.catch_type?.multiple"
				:placeholder="$t('filters.select_catch_type')"
				@input="filters.catch_type = $event"
			/>
		</div>
		<div v-if="isNeededFilter('catch_fish_type')" class="col-12 col-md-6 col-lg-3">
			<CatchFishType
				:value="filters.catch_fish_type"
				:with-title="false"
				:multiple="filterOptions?.catch_fish_type?.multiple"
				:placeholder="$t('filters.select_catch_fish_type')"
				@input="filters.catch_fish_type = $event"
			/>
		</div>
		<div v-if="isNeededFilter('fishes')" class="col-12 col-md-6 col-lg-3">
			<SelectFish
				:value="filters.fishes"
				:with-title="false"
				:multiple="filterOptions?.fishes?.multiple"
				:placeholder="$t('filters.select_fish')"
				@input="filters.fishes = $event"
			/>
		</div>
		<div v-if="isNeededFilter('fishing_year')" class="col-12 col-md-6 col-lg-3">
			<div class="form__line--input">
				<Multiselect
					v-model="filters.fishing_year"
					:options="fishingYearOptions"
					:searchable="false"
					:close-on-select="true"
					:show-labels="false"
					:allow-empty="true"
					:placeholder="$t('filters.select_fishing_year')"
					label="label"
					track-by="id"
					class="multiselect__check"
				>
					<template #placeholder>{{ $t('filters.fishing_year') }}</template>
				</Multiselect>
			</div>
		</div>
		<div v-if="isNeededFilter('brigades')" class="col-12 col-md-6 col-lg-3">
			<SelectBrigades
				:value="filters.brigades"
				:user-id="userId"
				:with-title="false"
				:multiple="filterOptions?.brigades?.multiple"
				:placeholder="$t('filters.select_brigade')"
				@input="filters.brigades = $event"
			/>
		</div>
		<div v-if="isNeededFilter('start_at')" class="col-12 col-md-6 col-lg-3">
			<div class="monitoring__line--date">
				<div class="monitoring__date--item w-full">
					<div class="monitoring__date--text">
						{{ $t('filters.after') }}
					</div>
					<div class="monitoring__date--input w-full">
						<input type="date" v-model="filters.start_at" class="date__input w-full" />
					</div>
				</div>
			</div>
		</div>
		<div v-if="isNeededFilter('finish_at')" class="col-12 col-md-6 col-lg-3">
			<div class="monitoring__line--date">
				<div class="monitoring__date--item w-full">
					<div class="monitoring__date--text">
						{{ $t('filters.before') }}
					</div>
					<div class="monitoring__date--input w-full">
						<input type="date" v-model="filters.finish_at" class="date__input w-full" />
					</div>
				</div>
			</div>
		</div>
		<!--
										<div class="table__filter--order">
											<multiselect
													class="select__status"
													v-model="filterCategories"
													:options="orderList"
													label="name"
													:clearOnSelect="false"
													:clear-on-select="false"
													:placeholder="$t('placeholder.choose')"
											>
												<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
												<template slot="noResult">{{ $t('components.not_found') }}</template>
											</multiselect>
										</div>
										-->
		<div class="col flex items-end gap-2">
			<button class="input-btn form__line--btn" @click="search">
				{{ $t('button.find') }}
			</button>
			<button class="btn--link btn--link--plus" @click.prevent.stop="clearFilter">
				{{ $t('button.clear') }}
			</button>
			<slot name="actions"></slot>
		</div>
	</div>
</template>
